import { TournamentApi, TeamApi, MatchApi, OrganizerApi } from "app/build/internal-api-clients";
import axios from "axios";
import Keycloak from "keycloak-js";

export class ApiProvider {
  private _axiosInstance = axios.create({});
  private _keycloak: Keycloak;

  private _getValidBearerToken = async (): Promise<string | undefined> => {
    if (this._keycloak.authenticated) {
      await this._keycloak.updateToken();
      return this._keycloak.token;
    }
    return undefined
  };

  readonly tournamentApi: TournamentApi;
  readonly teamApi: TeamApi;
  readonly matchApi: MatchApi;
  readonly organizerApi: OrganizerApi;

  constructor(keycloak: Keycloak) {
    this._keycloak = keycloak;
    this._axiosInstance.interceptors.request.use(async (config) => {
      const bearerToken = await this._getValidBearerToken();
      if (bearerToken) {
        config.headers["Authorization"] = `Bearer ${bearerToken}`;
      }
      return config;
    });
    const baseUrl = import.meta.env.VITE_BACKEND_BASE_URL ?? "/api";
    this.tournamentApi = new TournamentApi(undefined, baseUrl, this._axiosInstance);
    this.teamApi = new TeamApi(undefined, baseUrl, this._axiosInstance);
    this.matchApi = new MatchApi(undefined, baseUrl, this._axiosInstance);
    this.organizerApi = new OrganizerApi(undefined, baseUrl, this._axiosInstance);

  }
}
